import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { PortalAuthService } from './portal-auth.service';
@Injectable({ providedIn: 'root' })
export class PortalGuestGuard implements CanActivate {

	constructor(private auth: PortalAuthService, private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
		return this.auth.ensureSession().then(user => {
			if (!user) return true;
			const redirect = this.auth.safeReturnUrl(route.queryParamMap.get('redirect'));
			return this.router.parseUrl(redirect || '/');
		});
	}
}
